const resources = {
    cardTitle: 'Payment',
    expires: 'Exp',
    useGiftCard: 'Use a Gift Card',
    paypalRestrictedItemError: 'You have an item in Basket that cannot be purchased using PayPal. Please remove the item to continue checking out with PayPal or use a different payment method to continue checking out with the item.',
    giftCardNumber: 'Gift card number',
    pin: 'PIN',
    applyBtn: 'Apply',
    cancelBtn: 'Cancel',
    maxGiftCards: 'You’ve reached the maximum number of gift cards you can use for this order.',
    giftCard: 'Gift Card',
    applied: 'applied',
    remove: 'Remove',
    secure: 'Secure',
    payPalAccount: 'PayPal Account',
    payWithPayPal: 'Pay with PayPal',
    payNow: 'Pay now',
    or: 'or',
    payLaterWithPayPal: 'Pay Later with PayPal',
    payWithApplePay: 'Pay with ApplePay',
    addNewCreditCard: 'Add new credit or debit card',
    debitCardDisclaimer: 'Visa and Mastercard debit cards only',
    payPalDisabled: 'PayPal cannot be used when purchasing a subscription.',
    verifyCVV: 'No payment is required, please verify your CVV/CVC number for security purposes.',
    accountCredit: 'Account Credit',
    giftCardsNotCombinable: 'Gift cards are not combinable with this payment type.',
    removeCreditCard: 'Remove credit card or debit card',
    areYouSureMessage: 'Are you sure you would like to permanently remove this card?',
    removeGiftCard: 'Remove Gift Card',
    areYouSureGiftCardMessage: 'Are you sure you would like to remove this gift card from your order?',
    cancel: 'Cancel',
    expiredCreditCardMsg: 'This card is expired. Please update your card information.',
    edit: 'Edit',
    gotIt: 'Got It',
    cvc: 'CVV/CVC',
    moreInfoCvc: 'More info about CVV',
    storeCreditApplied: 'Account Credit',
    storeCreditNotEnoughMessage: 'Your Account Credit is less than the order total. Please add an additional payment method.',
    accountCreditAltText: 'Sephora Account Credit',
    paymentMethodSelection: 'Payment Method Selection',
    paymentInformation: 'Payment Information'
};

export default function getResource(label) {
    return resources[label];
}
